import { IconTruckDelivery } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import styles from './provinceDialog.module.scss';

interface ProvinceDialogProps {
  open: boolean;
  onClose: () => void;
}

const OFFICES = [
  { name: 'MBE Miraflores', reference: 'Cerca al parque Kennedy' },
  { name: 'MBE Panamá', reference: 'Cerca a Wong de Benavides (Miraflores)' },
  { name: 'MBE San Isidro', reference: 'Frente a Tottus de Las Begonias' },
  { name: 'MBE Surco', reference: 'Cruce de Av. Primavera con Av. El Polo' },
];

/**
 * Qué es un pedido con Envío Nacional y dónde se entrega. Lo abre el badge "Envío Nacional" de
 * Pedidos (regular y Match) y de Mis Ofertas. Los acuerdos tienen su propio diálogo, con
 * direcciones y horarios: `views/TravelerDeals/DealCard/ProvinceDialog`.
 */
const ProvinceDialog = (props: ProvinceDialogProps) => {
  const { open = false, onClose } = props;

  return (
    <Modal open={open} onClose={onClose}>
      {/* Ámbar: la identidad del badge "Envío Nacional" */}
      <ModalHeader icon={<IconTruckDelivery />} tone="warning">
        <ModalTitle>Pedidos con Envío Nacional</ModalTitle>
        <ModalDescription>
          Se deben entregar en una oficina de <strong>MailBoxes ETC</strong>.
        </ModalDescription>
      </ModalHeader>
      <ModalBody>
        <ul className={styles.offices} aria-label="Oficinas de MailBoxes ETC">
          {OFFICES.map((office) => (
            <li key={office.name} className={styles.office}>
              <strong>{office.name}</strong>
              <span>{office.reference}</span>
            </li>
          ))}
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Entendido</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ProvinceDialog;
